module.exports = __webpack_public_path__ + "static/media/mesonry-lg-5.782a019f.jpg";